<template lang='pug'>
.topContent-container()
    .t1(:class='{ m50: !smallTitle, m25: smallTitle }') 
        .bigTitle {{ bigTitle }}
        .collection-container
            img.collect(src='@/assets/imgs/collect@3x.png', v-if='!result')
            img.collect(
                src='@/assets/imgs/icon-collected-blue@3x.png',
                v-if='result'
            )
            .text(@click='shoucang') 收藏
    .t2(v-if='smallTitle') {{ smallTitle }}
    .bar
</template>

<script>
import { addBookmark, deleteBookmark, checkMember, getBookmarks} from '@/service/member'
import { mapState } from 'vuex'
export default {
    props: ['bigTitle', 'smallTitle', 'router', 'else', 'img', 'marketName', 'id', 'marketNameId', 'childMarketNameId', 'introduceId2', 'introduceId'],
    data() {
        return {
            name: this.$route.name,
            params: {},
            result: false,
            marketDetail: [],
            introduceDetail2: [],
            marketDetail2: [],
            data: [],
        }
    },
    computed:{
        ...mapState(['bookMarks','memberInfo'])
    },
    methods: {
        async updateData() {
            await this.$store.dispatch('getBookmarks', true)
            this.data = this.$store.state.bookMarks
            await this.initData()
        },
        async shoucang() {
            const {VUE_APP_MEMBER_FORMID,VUE_APP_FORM} =window.env
            let isMember =await checkMember(true)
            if(!isMember){
                window.location.href=`${VUE_APP_FORM}${VUE_APP_MEMBER_FORMID}?redirect=${encodeURIComponent(window.location.href)}`
            }
            if (this.name == 'introduceDetail2') {
                //当大标题和小标题都有的时候
                this.params = {
                    // introduceName: this.bigTitle,
                    // introduceName2: this.smallTitle,
                    introduceId: this.introduceId,
                    introduceId2: this.introduceId2
                }
                if (this.result) {
                    await deleteBookmark(this.result.id)
                    await this.updateData()
                } else {
                    await this.add()
                    await this.updateData()
                }
            } else if (this.name == 'marketDetail') {
                this.params = {
                    // marketName: this.marketName,
                    marketId: this.id,
                }
                if (this.result) {
                    await deleteBookmark(this.result.id)
                    await this.updateData()
                } else {
                    await this.add()
                    await this.updateData()
                }
            } else {
                this.params = {
                    // childMarketName: this.bigTitle,
                    // marketName: this.else,
                    childMarketNameId:this.childMarketNameId,
                    marketNameId:this.marketNameId
                }
                if (this.result) {
                    await deleteBookmark(this.result.id)
                    await this.updateData()
                } else {
                    await this.add()
                    await this.updateData()
                }
            }
        },
        async add() {
            if (this.name == 'marketDetail') {
                await addBookmark({
                    detail: {
                        type: 'content',
                        bigName: this.marketName,
                        smallName: this.bigTitle,
                        name: this.name,
                        params: this.params,
                        imga: this.img,
                    },
                    name: this.bigTitle,
                    url: window.location.href
                })
            } else if (this.name == 'marketDetail2') {
                await addBookmark({
                    detail: {
                        type: 'content',
                        bigName: this.else,
                        smallName: this.bigTitle,
                        name: this.name,
                        params: this.params,
                        imga: this.img,
                    },
                    name: this.bigTitle,
                    url: window.location.href
                })
            } else {
                await addBookmark({
                    detail: {
                        type: 'content',
                        bigName: this.bigTitle,
                        smallName: this.smallTitle,
                        name: this.name,
                        params: this.params,
                        imga: this.img,
                    },
                    name: this.smallTitle,
                    url: window.location.href
                })
            }
        },
        async initData() {
            this.marketDetail = []
            this.introduceDetail2 = []
            this.marketDetail2 = []
            this.data.forEach((val) => {
                if (val.detail.type == 'content') {
                    if (val.detail.name == 'marketDetail') {
                        this.marketDetail.push(val)
                    } else if (val.detail.name == 'introduceDetail2') {
                        this.introduceDetail2.push(val)
                    } else {
                        this.marketDetail2.push(val)
                    }
                }
            })
            if (this.name == 'introduceDetail2') {
                this.result = this.introduceDetail2.find((val) => {
                    return (
                        val.detail.bigName == this.bigTitle &&
                        val.detail.smallName == this.smallTitle
                    )
                })
            } else if (this.name == 'marketDetail') {
                this.result = this.marketDetail.find((val) => {
                    return val.detail.smallName == this.bigTitle
                })
            } else {
                this.result = this.marketDetail2.find((val) => {
                    return val.detail.smallName == this.bigTitle
                })
            }
        },
    },
    async mounted() {
        // this.data = this.$store.state.bookMarks
        // await this.initData()
    },
    watch: {
        bigTitle: {
            immediate:true,
            async handler(value){
                if(this.bookMarks){
                    this.data=this.bookMarks
                    await this.initData()
                }
            }
            
        }
    },
    async created() {
            // if(this.bookMarks){
            //     this.data=this.bookMarks
            //     await this.initData()
            // }
        // let a= (await getBookmarks()).data;
        // a.forEach(async (val)=>{
        //     await deleteBookmark(val.id)
        // })          //删除所有
    },
}
</script>

<style scoped lang='less'>
@import '~@/assets/style/mixin.less';
.topContent-container {
    .bar {
        width: 1.6rem;
        height: 0.25rem;
        background: #00448a;
    }
    .t2 {
        margin-bottom: 0.5rem;
        line-height: 0.9rem;
        color: #00448a;
    }
    .t1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .bigTitle {
            font-size: 0.8rem;
            color: #00448a;
            line-height: 1.1rem;
            width: 80%;
        }
        .collection-container {
            display: flex;
            align-items: center;
            .collect {
                width: 0.8rem;
                display: block;
                margin-right: 0.2rem;
            }
            .text {
                color: #219cdc;
                font-size: 0.6rem;
            }
        }
    }
}
.m50 {
    margin-bottom: 0.5rem;
}
.m25 {
    margin-bottom: 0.25rem;
}
</style>